import React, { Component } from 'react'

// MetisMenu
import MetisMenu from 'metismenujs'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
//i18n
import { withNamespaces } from 'react-i18next'
import { GeneralContext } from '../../context/'

class SidebarContent extends Component {
    static contextType = GeneralContext

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.initMenu()
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.initMenu()
        }
    }

    initMenu() {
        new MetisMenu("#side-menu")
        var matchingMenuItem = null
        var ul = document.getElementById("side-menu")
        var items = ul.getElementsByTagName("a")

        for (var i = 0; i < items.length; ++i) {
            if (this.props.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i]
                break
            }
        }

        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem)
        }
    }

    activateParentDropdown = (item) => {
        item.classList.add("active")
        const parent = item.parentElement

        if (parent) {
            parent.classList.add("mm-active")
            const parent2 = parent.parentElement

            if (parent2) {
                parent2.classList.add("mm-show")
                const parent3 = parent2.parentElement

                if (parent3) {
                    parent3.classList.add("mm-active") // li
                    parent3.childNodes[0].classList.add("mm-active") //a
                    const parent4 = parent3.parentElement
                    if (parent4) {
                        parent4.classList.add("mm-active")
                    }
                }
            }

            return false
        }

        return false
    }

    toggleMenu = () => {
        if (isMobile) {
            this.props.toggleMenuCallback()
        }
    }

    render() {
        return (
            <React.Fragment>
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">{this.props.t("Menu")}</li>
                        <li>
                            <Link
                                to="/home"
                                onClick={() => {
                                    this.context.setPagination([])
                                    this.toggleMenu()
                                }} 
                                className=" waves-effect"
                            >
                                <i className="bx bx-heart"></i>
                                <span>{this.props.t("Home")}</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/discovery" onClick={() => {
                                window.analytics.track(`Go to Discovery`)
                                this.toggleMenu()
                            }} className=" waves-effect">
                                <i className="mdi mdi-search-web"></i>
                                <span>{this.props.t("Discovery")}</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/marcas" onClick={() => {
                                window.analytics.track(`Go to Brands`)
                                this.context.setPagination([])
                                this.toggleMenu()
                            }} className=" waves-effect">
                                <i className="mdi mdi-tag-multiple"></i>
                                <span>{this.props.t("Marcas")}</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/pedidos" onClick={() => {
                                window.analytics.track(`Go to Orders`)
                                this.context.setPagination([])
                                this.toggleMenu()
                            }} className=" waves-effect">
                                <i className="bx bx-detail"></i>
                                <span>{this.props.t("Pedidos")}</span>
                            </Link>
                        </li>

                        {/* <li>
                            <Link to="/mi-tienda" onClick={() => this.toggleMenu()} className=" waves-effect">
                                <i className="bx bx-store"></i>
                                <span>{this.props.t("Mi tienda")}</span>
                            </Link>
                        </li> */}

                        {/* <li>
                            <a target="_blank"
                                href="https://vendoramx.zendesk.com/hc/es-419"
                                rel="noopener noreferrer"
                                onClick={() => {
                                    window.analytics.track(`Go to FAQs`)
                                    this.context.setPagination([])
                                    this.toggleMenu()
                                }}
                                className="waves-effect">
                                <i className="bx bx-help-circle"></i>
                                <span>{this.props.t("FAQs")}</span>
                            </a>
                        </li> */}

                        <li>
                            <Link to="/academia" onClick={() => { 
                                window.analytics.track(`Go to Vendora Academy`)
                                this.context.setPagination([])
                                this.toggleMenu()
                            }} className=" waves-effect">
                                <i className="mdi mdi-play-box-outline"></i>
                                <span>{this.props.t("Vendora Academy")}</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(withNamespaces()(SidebarContent))
